import React, { PropTypes } from "react";
import moment from "moment";
import Avatar from "components/Avatar/Avatar";
import CertificateLink from "./CertificateLink.jsx";
import constants from "constants";
import { cpdPoints, CPDPoints } from "components/CPDPoints";
import renderExperts from "components/Dashboard/renderExperts";
import renderSponsors from "components/Dashboard/renderSponsors";

const { CPD_STATUSES } = constants;

const CpdRecordedItem = ({
  webinar: {
    id,
    webinar_title,
    start_date,
    end_date,
    sponsor,
    is_quiz_completed,
    experts,
    sponsors,
  },
  webinar,
  onClick,
  token,
  isMobile,
  takeCpdQuiz,
}) => {
  const isCertificateOfParticipation =
    webinar.ref_type === "certificate_of_participation";

  const isCustomCertificate = isCertificateOfParticipation;

  if (isMobile) {
    return (
      <div className="section_live" onClick={onClick}>
        <p className="section_topic">{webinar_title}</p>
        <div className="section_info_mobile">
          <div className="section_topic_mobile">
            {webinar.vimeo_url && webinar.duration ? (
              <div>
                <p className="current_card_date">Duration</p>
                <p className="current_card_time">{webinar.duration}</p>
              </div>
            ) : (
              <div>
                <p className="current_card_date">
                  <span>
                    {moment(start_date).format("MMM DD").toUpperCase()}{" "}
                  </span>
                  {moment(start_date).format("YYYY")}
                </p>
                <p className="current_card_time">
                  {moment(start_date).format("h:mm a").toUpperCase()}
                  {" - "}
                  {moment(end_date).format("h:mm a").toUpperCase()}
                </p>
              </div>
            )}
            {webinar && webinar.document_url ? (
              <div className="col l1">
                <div className="current_points">
                  Agenda:{" "}
                  <a
                    className="download_attachment"
                    target="_blank"
                    href={webinar.document_url}
                  >
                    Download
                  </a>
                </div>
              </div>
            ) : null}
          </div>
          {renderExperts(experts)}
          <div className="section_sponsors_mobile">
            <div>
              {sponsors && sponsors.length && sponsors.length > 0 ? (
                <div>
                  <p>Brought to you by:</p>
                  {renderSponsors(sponsor, sponsors, false)}
                </div>
              ) : null}
            </div>
            <div className="section_sponsors_join">
              {webinar && webinar.cpd_points && !isCustomCertificate ? (
                <CPDPoints webinar={webinar} />
              ) : null}

              {isCertificateOfParticipation && (
                <p>Certificate of Participation</p>
              )}

              {is_quiz_completed &&
              (webinar.cpd_status === CPD_STATUSES.granted ||
                isCustomCertificate) ? (
                <CertificateLink token={token} webinarId={id} />
              ) : (
                <div className="container_download_cpd">
                  <div className="container_download col l1">
                    {webinar.cpd_status === CPD_STATUSES.granted && (
                      <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                          e.stopPropagation();
                          onClick(e);
                        }}
                      >
                        Take CPD Quiz
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* {partnerships && partnerships.length && partnerships.length > 0 ? (
            <div className="partnership-title-mobile">
              <p>In partnership with:</p>
              {renderPartners(partnerships)}
            </div>
          ) : null} */}
        </div>
      </div>
    );
  }

  return (
    <div className="section_live" onClick={onClick}>
      <p className="section_topic">{webinar_title}</p>
      <div className="section_info row">
        {/*<div className="col l2">*/}
        {/*  <p className="section_date">{moment(start_date).format('D/M/YYYY')}</p>*/}
        {/*  <p className="section_time">{moment(start_date).format('h:mm a').toUpperCase()}</p>*/}
        {/*</div>*/}
        <div className="col l4 webinar_title">
          <p className="section_live_theme"></p>
        </div>
        <div className="col l2 section_topic">
          {webinar.vimeo_url && webinar.duration ? (
            <div>
              <p className="current_card_date">Duration</p>
              <p className="current_card_time">{webinar.duration}</p>
            </div>
          ) : (
            <div>
              <p className="current_card_date">
                <span>
                  {moment(start_date).format("MMM DD").toUpperCase()}{" "}
                </span>
                {moment(start_date).format("YYYY")}
              </p>
              <p className="current_card_time">
                {moment(start_date).format("h:mm a").toUpperCase()}
                {" - "}
                {moment(end_date).format("h:mm a").toUpperCase()}
              </p>
            </div>
          )}
        </div>
        <div className="col l3">
          <p>Sponsored by:</p>
          {renderSponsors(sponsor, sponsors, false)}
        </div>
        {webinar && webinar.cpd_points && !isCustomCertificate ? (
          <div className="col l2">
            <p className="section_recorded_points">CPD Points</p>
            <p>{cpdPoints(webinar)}</p>
          </div>
        ) : null}

        {isCertificateOfParticipation && (
          <div className="col l2">
            <p>Certificate of Participation</p>
          </div>
        )}

        {is_quiz_completed &&
        (webinar.cpd_status === CPD_STATUSES.granted || isCustomCertificate) ? (
          <CertificateLink token={token} webinarId={id} />
        ) : (
          <div className="container_download_cpd">
            <div className="container_download col l1">
              {webinar.cpd_status === CPD_STATUSES.granted && (
                <a
                  href="javascript:void(0)"
                  onClick={(e) => {
                    e.stopPropagation();
                    onClick(e);
                  }}
                >
                  Take CPD Quiz
                </a>
              )}
            </div>
          </div>
        )}
      </div>
      {renderExperts(experts)}
    </div>
  );
};

CpdRecordedItem.propTypes = {
  onClick: PropTypes.func,
  webinar: PropTypes.obj,
};

export default CpdRecordedItem;



// WEBPACK FOOTER //
// ./src/components/CpdLocker/CpdRecordedItem.js